import ApiBase from '../ApiBase';

class ChatLike extends ApiBase {
    route = '/main-stage/sessions/:session/chats/:chat/likes';
}

export default new ChatLike;
